//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pcHeader from '../../components/pc/pcHeader'
import pcFooter from '../../components/pc/pcFooter'

export default {
  props: ['img'],
  components: {
    pcHeader,
    pcFooter
  },
  data () {
    return {}
  },
  computed: {
    leftCStyle () {
      return { backgroundImage: `url(${this.img})` }
    }
  },
  methods: {}
}
